import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { Typography, Grid } from "@mui/material";
import HeaderFooter from "../components/headerFooter";
import ButtonBlue from "../../../shared/buttonBlue";
import UnicornLoading from "../../../assets/loading.gif";
import BetweenSiteCarService from "../../../../../services/betweenSiteCar.service";
import { getBetweenSiteByAdminFilter } from "../../../../../actions/betweenSiteCarBooking";

require("dayjs/locale/th");
dayjs.locale("th");

const baseColumns = (driverLabel, dateTimeLabel) => [
  { id: "requester", label: "ผู้จอง", align: "center", width: "240px" },
  { id: "driverName", label: driverLabel, align: "center", width: "240px" },
  {
    id: "dateTimeStart",
    label: dateTimeLabel,
    align: "center",
    width: "140px",
  },
  { id: "place", label: "ต้นทาง - ปลายทาง", align: "center", width: "240px" },
  { id: "status", label: "สถานะ", align: "center", width: "140px" },
  { id: "action", label: "การจัดการ", align: "center", width: "80px" },
];

const columnsByStatus = {
  รอการจัดหาคนขับรถ: baseColumns("คนขับรถใกล้สุด", "วัน-เวลา ที่จอง"),
  กำลังดำเนินการ: baseColumns("คนขับรถ", "วัน-เวลา ที่รับผู้โดยสาร"),
  รายการเสร็จสิ้น: baseColumns("คนขับรถ", "วัน-เวลา ที่ส่งผู้โดยสาร"),
  ยกเลิกรายการ: baseColumns("คนขับรถ", "วัน-เวลา ที่จอง"),
};

const BetweenSiteCar = (props) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { result: AllBookingBetweenSite, isFetching: loading } = useSelector(
    (state) => state.betweenSiteCar
  );
  const [listBookingIsSuccess, setListBookingIsSuccess] = useState([]);
  const [listBookingNotSuccess, setListBookingNotSuccess] = useState([]);
  const [listBookingIsCancel, setListBookingIsCancel] = useState([]);
  const [listBookingWaitingForDriver, setListBookingWaitingForDriver] =
    useState([]);
  const [betweenSiteStatus, setBetweenSiteStatus] =
    useState("รอการจัดหาคนขับรถ");

  const onClickCardHandler = (typeOfBooking, idBooking) => {
    const booking = AllBookingBetweenSite?.find(
      (book) => book.idBetweenSiteCar === idBooking
    );

    if (booking) {
      props.history.push("/admin/car_management/between_site_car/detail", {
        booking: booking,
      });
    } else {
      console.warn("Booking not found for ID:", idBooking);
    }
  };

  const handleEditBooking = (idBooking) => {
    const booking = AllBookingBetweenSite?.find(
      (book) => book.idBetweenSiteCar === idBooking
    );

    if (booking) {
      props.history.push("/admin/car_management/between_site_car/edit_detail", {
        booking: booking,
      });
    } else {
      console.warn("Booking not found for ID:", idBooking);
    }
  };

  const [deletingBookingId, setDeletingBookingId] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const onClickDelete = async () => {
    const id = deletingBookingId;
    const data = {
      id: id,
    };
    console.log("deleting : " + id);
    if (id !== undefined && id) {
      await BetweenSiteCarService.deleteBetweenSiteCar(data)
        .then((res) => {
          if (res.status === 200) {
            enqueueSnackbar("Delete Success", { variant: "success" });
            setOpenDeleteModal(false);
            if (props.endDate) {
              let date = {
                startDate: new Date(props.startDate),
                endDate: new Date(props.endDate),
              };
              dispatch(
                getBetweenSiteByAdminFilter({
                  startDate: date.startDate,
                  endDate: date.endDate,
                })
              );
            } else {
              let date = {
                startDate: new Date(props.startDate),
              };
              dispatch(
                getBetweenSiteByAdminFilter({ startDate: date.startDate })
              );
            }
          } else {
            enqueueSnackbar("Cancel Failed", { variant: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const [cancelBookingId, setCancelBookingId] = useState("");
  const [openCancelModal, setOpenCancelModal] = useState(false);

  const onClickCancel = async () => {
    const id = cancelBookingId;
    console.log("cancel : " + id);
    if (id !== undefined && id) {
      BetweenSiteCarService.CancelCallCar({ bookingId: id })
        .then((res) => {
          if (res.status === 200) {
            enqueueSnackbar("Cancel Success", { variant: "success" });
            setOpenCancelModal(false);
            if (props.endDate) {
              let date = {
                startDate: new Date(props.startDate),
                endDate: new Date(props.endDate),
              };
              dispatch(
                getBetweenSiteByAdminFilter({
                  startDate: date.startDate,
                  endDate: date.endDate,
                })
              );
            } else {
              let date = {
                startDate: new Date(props.startDate),
              };
              dispatch(
                getBetweenSiteByAdminFilter({ startDate: date.startDate })
              );
            }
          } else {
            enqueueSnackbar("Cancel Failed", { variant: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const statusOptions = [
    {
      label: "รอการจัดหาคนขับรถ",
      color: "#F44336",
      hoverColor: "#d9392e",
      bgColor: "#ff091105",
    },
    {
      label: "กำลังดำเนินการ",
      color: "#FF9800",
      hoverColor: "#de8500",
      bgColor: "#ffb60005",
    },
    { label: "รายการเสร็จสิ้น" },
    {
      label: "ยกเลิกรายการ",
      color: "#b0b0b0",
      hoverColor: "#8f8f8f",
      bgColor: "#d2d2d206",
    },
  ];

  useEffect(() => {
    if (AllBookingBetweenSite && AllBookingBetweenSite.length) {
      const listA = [];
      const listB = [];
      const listC = [];
      const listD = [];

      const formatDate = (date) => dayjs(date).format("D MMM YYYY");
      const formatTime = (time) => dayjs(time).format("HH.mm") + " น.";

      AllBookingBetweenSite.map((booking) => {
        const formattedBooking = {
          bookingId: booking.idBetweenSiteCar,
          nameLabel: "ผู้จอง ",
          name: `${booking.firstnameEmployee} ${booking.lastnameEmployee}`,
          phone: booking.phoneRequester
            ? booking.phoneRequester
            : booking.phoneEmployee
            ? booking.phoneEmployee
            : null,
          driver: (booking.firstnameDriver && booking.lastnameDriver) ? booking.firstnameDriver + " " + booking.lastnameDriver : "รอการจัดหาคนขับรถ",
          startDateLabel: booking.isFinish
            ? booking.targetStatus === "Cancel" // Already Finish (Done / Cancel)
              ? "วัน-เวลา ที่จอง "
              : "วัน-เวลา ที่ส่งผู้โดยสาร "
            : // Not Finish Yet (Waiting Driver to Accept / Driver Accepted Booking)
            booking.targetStatus === "Waiting"
            ? "วัน-เวลา ที่จอง "
            : booking.targetStatus === "GettingPlace"
            ? "วัน-เวลา ที่รับผู้โดยสาร "
            : "วัน-เวลา ที่รับผู้โดยสาร ",
          startDate: booking.isFinish
            ? booking.targetStatus === "Cancel"
              ? formatDate(booking.date)
              : formatDate(booking.dropoffTime)
            : booking.targetStatus === "Waiting"
            ? formatDate(booking.date)
            : booking.targetStatus === "GettingPlace"
            ? "รอไปรับ"
            : formatDate(booking.pickupTime),
          startTime: booking.isFinish
            ? booking.targetStatus === "Cancel"
              ? formatTime(booking.date)
              : formatTime(booking.dropoffTime)
            : booking.targetStatus === "Waiting"
            ? formatTime(booking.date)
            : booking.targetStatus === "GettingPlace"
            ? ""
            : formatTime(booking.pickupTime),
          fromPlace: booking.fromPlace,
          toPlace: booking.toPlace,
          status: booking.isFinish
            ? booking.targetStatus === "Cancel"
              ? "ยกเลิกรายการ"
              : "รายการเสร็จสิ้น"
            : booking.targetStatus === "Waiting"
            ? "รอการจัดหาคนขับรถ"
            : "กำลังดำเนินการ",
        };

        if (booking.isFinish) {
          if (booking.targetStatus === "Cancel") {
            listC.push(formattedBooking);
          } else {
            listA.push(formattedBooking);
          }
        } else {
          if (booking.targetStatus === "Waiting") {
            listD.push(formattedBooking);
          } else {
            listB.push(formattedBooking);
          }
        }
      });

      setListBookingIsSuccess(listA);
      setListBookingNotSuccess(listB);
      setListBookingIsCancel(listC);
      setListBookingWaitingForDriver(listD);
    }
  }, [AllBookingBetweenSite]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
          paddingBlock: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
            flex: 1,
          }}
        >
          <div
            style={{
              minWidth: "220px",
              display: "flex",
              gap: "12px",
              overflowX: "auto",
              flexWrap: "wrap",
            }}
          >
            {statusOptions.map(({ label, color, hoverColor, bgColor }) => (
              <ButtonBlue
                key={label}
                variant={betweenSiteStatus === label ? "contained" : "outlined"}
                customColor={color}
                sx={
                  betweenSiteStatus === label
                    ? {
                        "&:hover": {
                          borderColor: hoverColor,
                          backgroundColor: hoverColor,
                        },
                      }
                    : {
                        "&:hover": {
                          backgroundColor: bgColor,
                          borderColor: hoverColor,
                        },
                      }
                }
                onClick={() => setBetweenSiteStatus(label)}
              >
                {label}
              </ButtonBlue>
            ))}
          </div>
        </div>

        <ButtonBlue
          variant="contained"
          startIcon={
            <img
              src="/assets/Image/Icon/form.png"
              alt="Logo"
              style={{ width: "20px", height: "20px" }}
            />
          }
          onClick={() => props.history.push("/betweenSite_Car")}
          sx={{ whiteSpace: "nowrap" }}
        >
          เพิ่มการจองรถ
        </ButtonBlue>
      </div>
      {!loading ? (
        <>
          {(listBookingIsSuccess && listBookingIsSuccess.length > 0) ||
          (listBookingNotSuccess && listBookingNotSuccess.length > 0) ||
          (listBookingIsCancel && listBookingIsCancel.length > 0) ||
          (listBookingWaitingForDriver &&
            listBookingWaitingForDriver.length > 0) ? (
            <HeaderFooter
              columns={columnsByStatus[betweenSiteStatus]}
              listAllBooking={
                betweenSiteStatus === "รายการเสร็จสิ้น"
                  ? listBookingIsSuccess
                  : betweenSiteStatus === "กำลังดำเนินการ"
                  ? listBookingNotSuccess
                  : betweenSiteStatus === "ยกเลิกรายการ"
                  ? listBookingIsCancel
                  : betweenSiteStatus === "รอการจัดหาคนขับรถ" &&
                    listBookingWaitingForDriver
              }
              typeOfBooking={"BetweenSiteCar"}
              onClickCardHandler={onClickCardHandler}
              listOfAction={
                betweenSiteStatus === "รายการเสร็จสิ้น"
                  ? ["edit", "delete"]
                  : betweenSiteStatus === "กำลังดำเนินการ"
                  ? ["edit", "cancel"]
                  : betweenSiteStatus === "ยกเลิกรายการ"
                  ? ["delete"]
                  : betweenSiteStatus === "รอการจัดหาคนขับรถ" && [
                      "edit",
                      "cancel",
                    ]
              }
              // deliverySampleStatus={deliverySampleStatus}
              handleEditBooking={handleEditBooking}
              onClickDelete={onClickDelete}
              setOpenDeleteModal={setOpenDeleteModal}
              setDeletingBookingId={setDeletingBookingId}
              openDeleteModal={openDeleteModal}
              onClickCancel={onClickCancel}
              setOpenCancelModal={setOpenCancelModal}
              setCancelBookingId={setCancelBookingId}
              openCancelModal={openCancelModal}
            />
          ) : (
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Typography style={{ textAlign: "center", fontSize: "24px" }}>
                ไม่มีรายการ
              </Typography>
            </Grid>
          )}
        </>
      ) : (
        <Grid item xs={12} container justifyContent="center" marginTop={2}>
          <img
            src={UnicornLoading}
            alt="Loading..."
            style={{ width: "300px" }}
          />
        </Grid>
      )}
    </div>
  );
};

export default BetweenSiteCar;
